<script>
import { Dialog, Popup, List, Picker } from 'vant'
import MemberIndexList from '@/components/org/MemberIndexList'
import CheckboxCard from '@/components/org/CheckboxCard'
import BottomToolbar from '@/components/org/BottomToolbar'

export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
	name: 'org-match-referee-list',

    //--------------------------------------------------
	// component components
	//--------------------------------------------------
    components: {
        'van-popup': Popup,
        'van-list': List,
        'van-picker': Picker,
        'member-index-list': MemberIndexList,
        'checkbox-card': CheckboxCard,
        'bottom-toolbar': BottomToolbar,
    },

    //--------------------------------------------------
    // component emits
    //--------------------------------------------------
	emits: ['custom-event'],

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
    data() {
        return {
            refereeList: null,
            organizationId: null,
            matchId: null,
            candicatedRefereeList: null,
            selectedRefereeList: null,
            showPopup: null,
            locale: {}
        }
    },

    //--------------------------------------------------
    // component computed
    //--------------------------------------------------
    computed: {
        operatorIconButtons() {
            console.log('operatorIconButtons')
            const iconButtons = []
            iconButtons.push({ type: 'import-referee', iconType: 'vant', icon: 'certificate', label: this.locale['import'] })
            iconButtons.push({ type: 'create-referee', iconType: 'vant', icon: 'add-o', label: this.locale['create'] })
            return iconButtons
        },
    },

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {
        onRefereeItemClick(item) {
            console.log('onRefereeItemClick', item)
            this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    name: 'OrgDetailReferee',
                    params: {
                        id: item.id
                    },
                    query: {
                        organizationId: this.organizationId,
                        matchId: this.matchId,
                        from: 'OrgListMatchReferee'
                    }
                }
            })
        },
        onRefereeItemCreate() {
            console.log('onCreateBtnClick')
            this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    name: 'OrgCreateMatchReferee',
                    param: {
                        id: this.matchId,
                    },
                    query: {
                        organizationId: this.organizationId,
                    }
                }
            })
        },
        onRefereeInvite(item) {
            console.log('onRefereeInvite', item)
            this.$emit('custom-event', {
                type: 'invite-referee',
                data: {
                    id: item.id,
                }
            })
        },
        onRefereeShift(item) {
            console.log('onRefereeShift', item)
            Dialog.confirm({
                title: this.locale['shift-match-referee'],
                message: this.locale['shift-match-referee-confirm-message']
            }).then(() => {
                // on confirm
                this.$emit('custom-event', {
                    type: 'delete',
                    data: {
                        id: item.id,
                        matchId: this.matchId,
                    }
                })
            }).catch(() => {
                // on cancel
            })
        },
        onCreateBtnClick() {
            console.log('onCreateBtnClick')
            this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    name: 'OrgCreateMatchReferee',
                    param: {
                        id: this.matchId,
                    },
                    query: {
                        organizationId: this.organizationId,
                    }
                }
            })
        },
        onImportBtnClick() {
            console.log('onImportBtnClick')
            this.$emit('custom-event', {
                type: 'load-referee',
                data: {
                    matchId: this.matchId
                }
            })
            this.selectedRefereeList = []
            this.showPopup = true
        },
        onBottomToolbarIconClick(type) {
            if (type == 'import-referee') {
                this.onImportBtnClick()
            }
            else if (type == 'create-referee') {
                this.onCreateBtnClick()
            }
        },
        onCancelBtnClick: function() {
            this.selectedRefereeList = []
            this.showPopup = false
        },
        onConfirmBtnClick: function() {
            if (this.selectedRefereeList.length > 0) {
                this.$emit('custom-event', {
                    type: 'add-referee',
                    data: {
                        matchId: this.matchId,
                        refereeList: this.selectedRefereeList
                    }
                })
            }
            this.selectedRefereeList = []
            this.showPopup = false
        },
        onCandicatedRefereeDataChange: function(data) {
            console.log('onCandicatedRefereeDataChange', data)
            if (data.opened) {
                this.selectedRefereeList.push(data.id)
            }
            else {
                const index = this.selectedRefereeList.indexOf(data.id)
                if (index > -1) {
                    this.selectedRefereeList.splice(index, 1)
                }
            }
        },
    },
}
</script>

<template>
    <div class="match-referee-list">
        <member-index-list
            :memberList="refereeList"
            :memberEmptyHint="locale['referee-empty-hint']"
            :memberInviteLabel="locale['invite-label']"
            @create-member="onRefereeItemCreate"
            @click-member="onRefereeItemClick"
            @invite-member="onRefereeInvite"
            @shift-member="onRefereeShift"
        />
        <bottom-toolbar
            type="icons"
            :mainIcons="operatorIconButtons"
            @click-main-icon="onBottomToolbarIconClick"
        />
        <van-popup v-model="showPopup" position="bottom">
            <div class="van-picker">
                <div class="van-picker__toolbar">
                    <button type="button" class="van-picker__cancel" @click="onCancelBtnClick">{{ locale['cancel'] }}</button>
                    <div class="van-ellipsis van-picker__title">{{ locale['import-match-referee'] }}</div>
                    <button type="button" class="van-picker__confirm" @click="onConfirmBtnClick">{{ locale['confirm'] }}</button>
                </div>
                <van-list class="popup-list">
                    <div v-for="item in candicatedRefereeList" :key="item.id" class="relative">
                        <checkbox-card 
                            :id="item.id"
                            :label="item.label" 
                            :subtext="item.subtext"
                            @change-data="onCandicatedRefereeDataChange"
                        />
                        <div class="separator-line-bottom"/>
                    </div>
                </van-list>
            </div>
        </van-popup>
    </div>
</template>

<style scoped>
.popup-list {
    max-height: 80vh; 
    overflow-y: scroll;
    padding-left: 4px;
    padding-right: 4px;
}
</style>